var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (columns, continueBtnText, doneText, game, hasNarration, hasPrompt, i18n, isLong, metadata, prompt, submitUp, title, undefined) {
if ( game && game.timer && game.timer.limit > 0 && !game.timer.isDisabled)
{
buf.push("<div class=\"full-screen\"><div class=\"game-stepper text-lg text-bold\"></div><div class=\"game-progress\"><div class=\"game-progress-bar\"></div></div></div>");
}
buf.push("<div class=\"block-v-xl content-ver text-center content-scroll\"><div class=\"content-scroll-inner\"><h1 class=\"block-v-sm fade-in\">" + (null == (jade_interp = title) ? "" : jade_interp) + "</h1><div class=\"row\">");
// iterate metadata.questions
;(function(){
  var $$obj = metadata.questions;
  if ('number' == typeof $$obj.length) {

    for (var j = 0, $$l = $$obj.length; j < $$l; j++) {
      var column = $$obj[j];

buf.push("<div" + (jade.cls(['col-sm-12','block-v-sm',columns.length > 2 ? "col-md-4" : "col-md-6"], [null,null,true])) + "><div" + (jade.cls(['block-dk','block-sm','fade-in',"delay-" + (j) + ""], [null,null,null,true])) + ">");
var questionDetails = column.question || column.questionDetails || {};
buf.push("<div class=\"block-sm text-bold text-md\">" + (null == (jade_interp = questionDetails.content) ? "" : jade_interp) + "</div>");
// iterate column.answers
;(function(){
  var $$obj = column.answers;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var answer = $$obj[i];

buf.push("<div" + (jade.attr("data-column", j, true, false)) + (jade.attr("data-correct", answer.correct, true, false)) + (jade.attr("data-question-id", questionDetails.id, true, false)) + (jade.attr("data-answer-id", answer.id, true, false)) + " class=\"selectable block-sm fade-in\"><div" + (jade.cls(['btn','btn-solid','btn-block','slide-up',(isLong ? "btn-long" : "") + " delay-" + (i) + ""], [null,null,null,null,true])) + ">" + (null == (jade_interp = answer.content != null && answer.content != undefined ? answer.content : "&nbsp;") ? "" : jade_interp) + "</div></div>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var answer = $$obj[i];

buf.push("<div" + (jade.attr("data-column", j, true, false)) + (jade.attr("data-correct", answer.correct, true, false)) + (jade.attr("data-question-id", questionDetails.id, true, false)) + (jade.attr("data-answer-id", answer.id, true, false)) + " class=\"selectable block-sm fade-in\"><div" + (jade.cls(['btn','btn-solid','btn-block','slide-up',(isLong ? "btn-long" : "") + " delay-" + (i) + ""], [null,null,null,null,true])) + ">" + (null == (jade_interp = answer.content != null && answer.content != undefined ? answer.content : "&nbsp;") ? "" : jade_interp) + "</div></div>");
    }

  }
}).call(this);

buf.push("</div></div>");
    }

  } else {
    var $$l = 0;
    for (var j in $$obj) {
      $$l++;      var column = $$obj[j];

buf.push("<div" + (jade.cls(['col-sm-12','block-v-sm',columns.length > 2 ? "col-md-4" : "col-md-6"], [null,null,true])) + "><div" + (jade.cls(['block-dk','block-sm','fade-in',"delay-" + (j) + ""], [null,null,null,true])) + ">");
var questionDetails = column.question || column.questionDetails || {};
buf.push("<div class=\"block-sm text-bold text-md\">" + (null == (jade_interp = questionDetails.content) ? "" : jade_interp) + "</div>");
// iterate column.answers
;(function(){
  var $$obj = column.answers;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var answer = $$obj[i];

buf.push("<div" + (jade.attr("data-column", j, true, false)) + (jade.attr("data-correct", answer.correct, true, false)) + (jade.attr("data-question-id", questionDetails.id, true, false)) + (jade.attr("data-answer-id", answer.id, true, false)) + " class=\"selectable block-sm fade-in\"><div" + (jade.cls(['btn','btn-solid','btn-block','slide-up',(isLong ? "btn-long" : "") + " delay-" + (i) + ""], [null,null,null,null,true])) + ">" + (null == (jade_interp = answer.content != null && answer.content != undefined ? answer.content : "&nbsp;") ? "" : jade_interp) + "</div></div>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var answer = $$obj[i];

buf.push("<div" + (jade.attr("data-column", j, true, false)) + (jade.attr("data-correct", answer.correct, true, false)) + (jade.attr("data-question-id", questionDetails.id, true, false)) + (jade.attr("data-answer-id", answer.id, true, false)) + " class=\"selectable block-sm fade-in\"><div" + (jade.cls(['btn','btn-solid','btn-block','slide-up',(isLong ? "btn-long" : "") + " delay-" + (i) + ""], [null,null,null,null,true])) + ">" + (null == (jade_interp = answer.content != null && answer.content != undefined ? answer.content : "&nbsp;") ? "" : jade_interp) + "</div></div>");
    }

  }
}).call(this);

buf.push("</div></div>");
    }

  }
}).call(this);

buf.push("</div></div></div><div" + (jade.cls(['slide-footer','block-v-lg',submitUp ? "slide-footer--up slide-down" : "slide-up"], [null,null,true])) + ">");
if ( hasPrompt)
{
buf.push("<div class=\"slide-footer-touched\"><div class=\"btn btn-muted btn-done text-ellipsis\">" + (null == (jade_interp = doneText) ? "" : jade_interp) + "</div></div>");
if ( typeof prompt === "string")
{
buf.push("<div class=\"slide-footer-prompt text-uppercase text-bold\"><div class=\"slide-footer-prompt-content content-ver\">" + (null == (jade_interp = prompt) ? "" : jade_interp) + "</div></div>");
}
}
else
{
buf.push("<div class=\"slide-footer-prompt\"><div class=\"btn btn-muted btn-done text-ellipsis content-ver\">" + (null == (jade_interp = continueBtnText || i18n("buttons.continue")) ? "" : jade_interp) + "</div></div>");
}
if ( hasNarration)
{
buf.push("<div class=\"slide-footer-narration\"><div class=\"narration-progress btn btn-muted\"><div class=\"narration-progress-bar\"></div><div class=\"wave-ellipse\"><span class=\"bullet delay-1 block-inline\">&bullet;</span><span class=\"bullet delay-2 block-inline\">&bullet;</span><span class=\"bullet delay-3 block-inline\">&bullet;</span></div></div></div>");
}
buf.push("</div>");}.call(this,"columns" in locals_for_with?locals_for_with.columns:typeof columns!=="undefined"?columns:undefined,"continueBtnText" in locals_for_with?locals_for_with.continueBtnText:typeof continueBtnText!=="undefined"?continueBtnText:undefined,"doneText" in locals_for_with?locals_for_with.doneText:typeof doneText!=="undefined"?doneText:undefined,"game" in locals_for_with?locals_for_with.game:typeof game!=="undefined"?game:undefined,"hasNarration" in locals_for_with?locals_for_with.hasNarration:typeof hasNarration!=="undefined"?hasNarration:undefined,"hasPrompt" in locals_for_with?locals_for_with.hasPrompt:typeof hasPrompt!=="undefined"?hasPrompt:undefined,"i18n" in locals_for_with?locals_for_with.i18n:typeof i18n!=="undefined"?i18n:undefined,"isLong" in locals_for_with?locals_for_with.isLong:typeof isLong!=="undefined"?isLong:undefined,"metadata" in locals_for_with?locals_for_with.metadata:typeof metadata!=="undefined"?metadata:undefined,"prompt" in locals_for_with?locals_for_with.prompt:typeof prompt!=="undefined"?prompt:undefined,"submitUp" in locals_for_with?locals_for_with.submitUp:typeof submitUp!=="undefined"?submitUp:undefined,"title" in locals_for_with?locals_for_with.title:typeof title!=="undefined"?title:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}